export type CurrencyCode = 'COP' | 'USD' | 'EUR'

export const CURRENCIES: Record<CurrencyCode, { symbol: string; label: string; flag: string }> = {
  COP: { symbol: '$', label: 'Pesos colombianos', flag: '🇨🇴' },
  USD: { symbol: 'US$', label: 'Dólares', flag: '🇺🇸' },
  EUR: { symbol: '€', label: 'Euros', flag: '🇪🇺' },
}

/** Precios mensuales por plan en cada moneda */
export const PLAN_PRICES: Record<'premium' | 'familia', Record<CurrencyCode, number>> = {
  premium: { COP: 20000, USD: 4.99, EUR: 4.99 },
  familia: { COP: 35000, USD: 9.99, EUR: 9.99 },
}

/** Límite de dispositivos por plan (según lo ofrecido en la landing) */
export const PLAN_DEVICE_LIMITS: Record<string, number> = {
  trial: 1,
  premium: 4,
  familia: 10,
}

export function deviceLimitFor(billing?: { plan?: string; planTier?: string }): number {
  if (billing?.plan === 'monthly') {
    return PLAN_DEVICE_LIMITS[billing.planTier ?? 'familia'] ?? 15
  }
  return PLAN_DEVICE_LIMITS['trial'] ?? 1
}

export function formatPrice(amount: number, code: CurrencyCode): string {
  const { symbol } = CURRENCIES[code]
  if (code === 'COP') {
    const rounded = Math.round(amount)
    const withDots = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    return `${symbol}${withDots}`
  }
  return `${symbol}${amount.toFixed(2)}`
}

const STORAGE_KEY = 'kidsafe_currency'

export function getStoredCurrency(): CurrencyCode {
  try {
    const saved = localStorage.getItem(STORAGE_KEY)
    if (saved === 'USD' || saved === 'EUR' || saved === 'COP') return saved
  } catch {
    /* localStorage no disponible */
  }
  return 'COP'
}

export function setStoredCurrency(code: CurrencyCode) {
  try {
    localStorage.setItem(STORAGE_KEY, code)
  } catch {
    /* ignorar */
  }
}